'use client'

import { DeviceTypeProvider } from '@/context/device-type-context/device-type-provider'
import { FeatureFlagProvider } from '@/context/feature-flag-context/feature-flag-context'
import { MessagesProvider } from '@/context/messages-context/messages-context'
import { ModalProvider } from '@/context/modal-context/modal-context'
import type { DeviceType } from '@/utils/getIsMobileServer'
import * as React from 'react'

type Props = {
  deviceType?: DeviceType
  children: React.ReactNode
}

export const Providers: React.FC<Props> = ({
  deviceType = 'desktop',
  children,
}) => {
  return (
    <DeviceTypeProvider deviceType={deviceType}>
      <FeatureFlagProvider>
        <MessagesProvider>
          <ModalProvider>{children}</ModalProvider>
        </MessagesProvider>
      </FeatureFlagProvider>
    </DeviceTypeProvider>
  )
}
